import ConfettiComponent from "@/components/confetti";
import { SupportMessage } from "@/components/layout-loading/support-message";
import { Button } from "@/components/ui/button";
import { useApi } from "@/hooks/useApi";
import { useTranslation } from "@/hooks/useTranslation";
import { useEffect, useState } from "react";

export const SetupBillingFinishPage = () => {
  const { t } = useTranslation();
  const api = useApi();

  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const closeBilling = async () => {
    try {
      setIsLoading(true);
      await api.post(`/my/team/setup/finish`);
      setIsSuccess(true);
    } catch (error) {
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    closeBilling();
  }, []);

  const reload = () => {
    window.location.reload();
  };
  const redirectToHome = () => {
    window.location.href = "/";
  };

  if (isLoading) {
    return <div>{t("setup.billing.finish.loading")}</div>;
  }

  if (!isSuccess) {
    return (
      <div className="space-y-5 text-center">
        <h1 className="text-2xl font-bold text-primary">
          {t("setup.billing.finish.error.title")}
        </h1>
        <p>{t("setup.billing.finish.error.description")}</p>
        <SupportMessage />
        <Button onClick={reload}>
          {t("setup.billing.finish.buttons.retry")}
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-5 text-center">
      <h1 className="text-2xl font-bold text-primary">
        {t("setup.billing.finish.success.title")}
      </h1>
      <p className="text-md">{t("setup.billing.finish.success.description")}</p>
      <Button onClick={redirectToHome}>
        {t("setup.billing.finish.buttons.home")}
      </Button>
      <ConfettiComponent />
    </div>
  );
};
